
const g:any = window[ENV.projectName] = window[ENV.projectName] || {};

import { Component, Vue, Watch } from 'vue-property-decorator';

import { mainStore } from '../_store/main';

import { ShapeKeys, PointCloudDefinition } from '../_modules/webgl/PointCloud';
import { SimpleLayoutMode } from '../_types/common';

import PageComponent from '../_modules/PageComponent';
import MainGL from '../_modules/webgl/MainGL';

import TechnologySections, { TechnologySection } from '../_modules/TechnologySections';

const TechnologyScrollState = {
  KV     : 'KV'     ,
  IOT    : 'IOT'    ,
  BIM    : 'BIM'    ,
  CHAIN  : 'CHAIN'  ,
  SERVICE: 'SERVICE',
  CONTACT: 'CONTACT',
} as const;

export const TechnologyGLDefinition: PointCloudDefinition = {
  KV: {
    key: 'KV',
    shapeKey: 'KV',
    isKV: true,
    order: 0,
    kvItems: [
      { key: '', shapeKey: ShapeKeys.BRAIN, order: 0 },
      { key: '', shapeKey: ShapeKeys.BRAIN, order: 1 },
      { key: '', shapeKey: ShapeKeys.BRAIN, order: 2 },
      { key: '', shapeKey: ShapeKeys.BRAIN, order: 3 },
   ]
  },
  IOT     : { key: 'IOT'     , shapeKey: ShapeKeys.IOT     , order: 1 },
  BIM     : { key: 'BIM'     , shapeKey: ShapeKeys.BIM     , order: 2 },
  CHAIN   : { key: 'CHAIN'   , shapeKey: ShapeKeys.CHAIN   , order: 3 },
  SERVICE : { key: 'SERVICE' , shapeKey: ShapeKeys.IEGAO   , order: 4 },
  CONTACT : { key: 'CONTACT' , shapeKey: ShapeKeys.CONTACT , order: 5 },
};


export default class Main extends PageComponent {
  protected memberEl!: HTMLElement;

  protected sections!: TechnologySections;
  protected sectionsEl!: HTMLElement;
  protected sectionsObserver!: IntersectionObserver;
  protected sectionsOffsetTop: number = 0;

  protected iot!: TechnologySection;
  protected iotObserver!: IntersectionObserver;

  protected bim!: TechnologySection;
  protected bimObserver!: IntersectionObserver;

  protected chain!: TechnologySection;
  protected chainObserver!: IntersectionObserver;

  protected serviceEl!: HTMLElement;
  protected serviceImgEl!: HTMLElement;
  protected serviceObserver!: IntersectionObserver;

  protected isLockedBySections: boolean = false;
  protected beforeTouchY: number = 0;

  constructor() {
    super();
    this.init();
  }

  get isKV      () { return this.scrollState === TechnologyScrollState.KV      }
  get isIOT     () { return this.scrollState === TechnologyScrollState.IOT     }
  get isBIM     () { return this.scrollState === TechnologyScrollState.BIM     }
  get isChain   () { return this.scrollState === TechnologyScrollState.CHAIN   }
  get isService () { return this.scrollState === TechnologyScrollState.SERVICE }
  get isContact () { return this.scrollState === TechnologyScrollState.CONTACT }

  protected onTouchStart(e: TouchEvent) {
    const touchY = e.touches[0].clientY;
    this.beforeTouchY = touchY;
  }

  protected onTouchMove(e: TouchEvent) {
    this.killScrollTween();

    const touchY = e.touches[0].clientY;
    const delta = -(touchY - this.beforeTouchY);
    this.beforeTouchY = touchY;

    if(this.isLocked) {
      e.preventDefault();
      e.stopImmediatePropagation();
      return;
    }

    if(this.sections.getActive()) {
      if(delta > 0) {
        // 順方向
        if(mainStore.scrollTop >= this.sectionsOffsetTop && this.sections.isFirst) {
          // スクロールロック
          this.killScrollTween();
          this.isLockedBySections = true;
          window.scrollTo(0, this.sectionsOffsetTop);
        }

        if(this.isLockedBySections && !this.sections.isAnimating) {
          if(this.sections.isLast) {
            // ロック解除
            this.isLockedBySections = false;
            this.sections.setActive(false);
          } else {
            this.sections.next();
            if(this.sections.currentIndex === 0) this.mainGL.setMode(TechnologyScrollState.IOT);
            if(this.sections.currentIndex === 1) this.mainGL.setMode(TechnologyScrollState.BIM);
            if(this.sections.currentIndex === 2) this.mainGL.setMode(TechnologyScrollState.CHAIN);
          }

        }

      } else {
        // 逆方向
        if(mainStore.scrollTop <= this.sectionsOffsetTop && this.sections.isLast) {
          // スクロールロック
          this.killScrollTween();
          this.isLockedBySections = true;
          window.scrollTo(0, this.sectionsOffsetTop);
        }

        if(this.isLockedBySections && !this.sections.isAnimating) {
          if(this.sections.isFirst) {
            // ロック解除
            this.isLockedBySections = false;
            this.sections.setActive(false);
          } else {
            this.sections.prev();
            if(this.sections.currentIndex === 0) this.mainGL.setMode(TechnologyScrollState.IOT);
            if(this.sections.currentIndex === 1) this.mainGL.setMode(TechnologyScrollState.BIM);
            if(this.sections.currentIndex === 2) this.mainGL.setMode(TechnologyScrollState.CHAIN);
          }

        }
      }
    }

    if(this.isLockedBySections) {
      this.killScrollTween();
      window.scrollTo(0, this.sectionsOffsetTop);
      e.preventDefault();
      e.stopImmediatePropagation();
    }
  }

  protected onWheel(e: WheelEvent): void {
    this.killScrollTween();

    if(this.isLocked) {
      e.preventDefault();
      e.stopImmediatePropagation();
      return;
    }

    const delta = e.deltaY;

    if(this.sections.getActive()) {
      if(delta > 0) {
        // 順方向
        if(mainStore.scrollTop >= this.sectionsOffsetTop && this.sections.isFirst) {
          // スクロールロック
          this.killScrollTween();
          this.isLockedBySections = true;
          window.scrollTo(0, this.sectionsOffsetTop);
        }

        if(this.isLockedBySections && !this.sections.isAnimating) {
          if(this.sections.isLast) {
            // ロック解除
            this.isLockedBySections = false;
            this.sections.setActive(false);
          } else {
            this.sections.next();
            if(this.sections.currentIndex === 0) this.mainGL.setMode(TechnologyScrollState.IOT);
            if(this.sections.currentIndex === 1) this.mainGL.setMode(TechnologyScrollState.BIM);
            if(this.sections.currentIndex === 2) this.mainGL.setMode(TechnologyScrollState.CHAIN);
          }

        }

      } else {
        // 逆方向
        if(mainStore.scrollTop <= this.sectionsOffsetTop && this.sections.isLast) {
          // スクロールロック
          this.killScrollTween();
          this.isLockedBySections = true;
          window.scrollTo(0, this.sectionsOffsetTop);
        }

        if(this.isLockedBySections && !this.sections.isAnimating) {
          if(this.sections.isFirst) {
            // ロック解除
            this.isLockedBySections = false;
            this.sections.setActive(false);
          } else {
            this.sections.prev();
            if(this.sections.currentIndex === 0) this.mainGL.setMode(TechnologyScrollState.IOT);
            if(this.sections.currentIndex === 1) this.mainGL.setMode(TechnologyScrollState.BIM);
            if(this.sections.currentIndex === 2) this.mainGL.setMode(TechnologyScrollState.CHAIN);
          }

        }
      }
    }

    if(this.isLockedBySections) {
      this.killScrollTween();
      window.scrollTo(0, this.sectionsOffsetTop);
      e.preventDefault();
      e.stopImmediatePropagation();
    }
  }

  protected async initObservers() {
    await this.wait(400);

    this.initPageKVObserver();
    this.initSectionsObserver();
    this.initIOTObserver();
    this.initBIMObserver();
    this.initChainObserver();
    this.initServiceObserver();
    this.initContactLinkObserver();
  }

  protected async initIOT() {
    const el = this.bodyElm.querySelector('.js-technologyIOT') as HTMLElement;
    this.iot = new TechnologySection({ el });
    await this.iot.$nextTick();
    return this.onScreenItemManager.initItem(this.iot)
  }
  protected async initBIM() {
    const el = this.bodyElm.querySelector('.js-technologyVR') as HTMLElement;
    this.bim = new TechnologySection({ el });
    await this.bim.$nextTick();
    return this.onScreenItemManager.initItem(this.bim)
  }
  protected async initChain() {
    const el = this.bodyElm.querySelector('.js-technologyChain') as HTMLElement;
    this.chain = new TechnologySection({ el });
    await this.chain.$nextTick();
    return this.onScreenItemManager.initItem(this.chain)
  }

  protected async initSections() {
    this.sectionsEl = this.bodyElm.querySelector('.js-technologySections') as HTMLElement;
    this.sections = new TechnologySections({ el: this.sectionsEl });
    await this.sections.$nextTick();

    await Promise.all([
      this.initIOT(),
      this.initBIM(),
      this.initChain(),
    ]);

    await this.sections.init([
      this.iot, this.bim, this.chain
    ]);
  }

  protected initSectionsObserver() {
    if(!window.IntersectionObserver || g.isGoogleBot) return;

    this.iotObserver = new IntersectionObserver((entries)=> {
      if(mainStore.simpleLayoutMode === SimpleLayoutMode.S) return;

      const entry = entries[0];
      if(entry.isIntersecting) {
        if(this.scrollState === '' ||
          (((!this.isIOT && this.sections.isFirst) || (!this.isChain && this.sections.isLast)) &&
            ((this.scrollDir === 1 && this.isKV) || (this.scrollDir === -1 && !this.isKV))
          )
        ) {
          this.sections.setActive(true);
          if(this.sections.isFirst) {
            this.sections.setIndex(0);
            this.scrollState = TechnologyScrollState.IOT;
            console.log('scroll state:', TechnologyScrollState.IOT);
            this.mainGL.setMode(TechnologyScrollState.IOT);

          } else if(this.sections.isLast) {
            this.scrollState = TechnologyScrollState.CHAIN;
            console.log('scroll state:', TechnologyScrollState.CHAIN);
            this.mainGL.setMode(TechnologyScrollState.CHAIN);

          }
        }
      }
    }, {
      threshold: [0, 0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.7, 0.8, 0.9, 1],
      rootMargin: '-10% 0px'
    });
    console.log(this.sections.$el);
    this.iotObserver.observe(this.sections.$el);
  }

  protected initIOTObserver() {
    if(!window.IntersectionObserver || g.isGoogleBot) return;

    this.iotObserver = new IntersectionObserver((entries)=> {
      if(mainStore.simpleLayoutMode === SimpleLayoutMode.L) return;

      const entry = entries[0];
      if(entry.isIntersecting) {
        if(this.scrollState === '' ||
          (!this.isIOT &&
            ((this.scrollDir === 1 && this.isKV) || (this.scrollDir === -1 && !this.isKV))
          )
        ) {
          this.scrollState = TechnologyScrollState.IOT;
          console.log('scroll state:', TechnologyScrollState.IOT);
          this.mainGL.setMode(TechnologyScrollState.IOT);

        }
      }
    }, {
      threshold: [0, 0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.7, 0.8, 0.9, 1],
      rootMargin: '-10% 0px'
    });
    this.iotObserver.observe(this.iot.visual);
  }
  protected initBIMObserver() {
    if(!window.IntersectionObserver || g.isGoogleBot) return;

    this.iotObserver = new IntersectionObserver((entries)=> {
      if(mainStore.simpleLayoutMode === SimpleLayoutMode.L) return;

      const entry = entries[0];
      if(entry.isIntersecting) {
        if(this.scrollState === '' ||
          (!this.isBIM &&
            ((this.scrollDir === 1 && (this.isKV || this.isIOT)) || (this.scrollDir === -1 && (!this.isKV && !this.isIOT)))
          )
        ) {
          this.scrollState = TechnologyScrollState.BIM;
          console.log('scroll state:', TechnologyScrollState.BIM);
          this.mainGL.setMode(TechnologyScrollState.BIM);

        }
      }
    }, {
      threshold: [0, 0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.7, 0.8, 0.9, 1],
      rootMargin: '-10% 0px'
    });
    this.iotObserver.observe(this.bim.visual);
  }
  protected initChainObserver() {
    if(!window.IntersectionObserver || g.isGoogleBot) return;

    this.iotObserver = new IntersectionObserver((entries)=> {
      if(mainStore.simpleLayoutMode === SimpleLayoutMode.L) return;

      const entry = entries[0];
      if(entry.isIntersecting) {
        if(this.scrollState === '' ||
          (!this.isChain &&
            ((this.scrollDir === 1 && !this.isContact && !this.isService) || (this.scrollDir === -1 && (this.isContact || this.isService)))
          )
        ) {
          this.scrollState = TechnologyScrollState.CHAIN;
          console.log('scroll state:', TechnologyScrollState.CHAIN);
          this.mainGL.setMode(TechnologyScrollState.CHAIN);

        }
      }
    }, {
      threshold: [0, 0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.7, 0.8, 0.9, 1],
      rootMargin: '-10% 0px'
    });
    this.iotObserver.observe(this.chain.visual);
  }

  protected async initService() {
    this.serviceEl = this.bodyElm.querySelector('.js-technologyService') as HTMLElement;
    this.serviceImgEl = this.serviceEl.querySelector('.js-technologyServiceImg') as HTMLElement;
  }

  protected initServiceObserver() {
    if(!window.IntersectionObserver || g.isGoogleBot) return;

    this.serviceObserver = new IntersectionObserver((entries)=> {
      const entry = entries[0];
      if(entry.isIntersecting) {
        if(this.scrollState === '' ||
          (!this.isService &&
            ((this.scrollDir === 1 && !this.isContact) || (this.scrollDir === -1 && this.isContact))
          )
        ) {
          this.scrollState = TechnologyScrollState.SERVICE;
          console.log('scroll state:', TechnologyScrollState.SERVICE);
          this.mainGL.setMode(TechnologyScrollState.SERVICE);

        }
      }
    }, {
      threshold: [0, 0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.7, 0.8, 0.9, 1],
      rootMargin: '-10% 0px'
    });
    this.serviceObserver.observe(this.serviceEl);
  }

  protected initScroll(): void {
    super.initScroll();
    window.addEventListener('touchstart', this.onTouchStart.bind(this), { passive: false });
    window.addEventListener('touchmove', this.onTouchMove.bind(this), { passive: false });
  }

  protected async init(): Promise<void> {
    mainStore.setCurrentPageId('technology');

    this.scrollToTweenObj = { value: window.scrollY || window.pageYOffset };

    await Promise.all([
      g.loadFontPromise,
      this.initMainGL(),
      this.initLoading(),
      this.initHeader(),
      this.initFooter(),
      this.initMenu(),
    ]);

    await this.initContents();

    this.initMediaQuery();
    this.initScroll();
    this.initResize();

    this.resizeHandler();

    mainStore.setScrolled(false);
    mainStore.setLoaded(true);

    this.initObservers();

    await this.pageKV.$nextTick();

    this.isLocked = false;
    this.onResize();
    this.onScroll();
    this.play();
  }

  protected async initContents(): Promise<void> {
    await Promise.all([
      this.initPageKV(),
      this.initSections(),
      this.initService(),
      this.initContact(),
    ]);
    await super.initContents();
  }

  protected async initMainGL() {
    const mainGLEl = this.bodyElm.querySelector('.js-mainGL') as HTMLElement;

    this.mainGL = new MainGL<typeof TechnologyGLDefinition>(
      mainGLEl,
      mainGLEl.querySelector('canvas') as HTMLCanvasElement,
      TechnologyGLDefinition,
      'KV',
      false
    );

    await this.mainGL.init()
    .catch((e)=> {
      console.log(e);
      this.htmlElm.classList.add('is-noWebGL');
      mainStore.setNoWebGL(true);
    })

    this.mainGL.onResize();
  }

  protected async onResize() {
    this.sections.onResize();
    this.sectionsOffsetTop = this.sections.getAnchorOffsetTop();
    if(mainStore.simpleLayoutMode === SimpleLayoutMode.S) {
      this.isLockedBySections = false;
    }
    await this.sections.$nextTick();
    this.mainGL.onResize();
    this.updateGLScales();
  }

  protected onScroll(): void {
    super.onScroll();
    this.mainGL.setScrollTop();
  }

  protected updateGLScales() {
    const kvImgEl = this.pageKV.getImgContainer()

    this.mainGL.setParams({
      KV: {
        imgSize: kvImgEl.offsetWidth || 1,
        offset: this.getOffsetImgItem(kvImgEl, true)
      },
      IOT: {
        imgSize: this.iot.visual.offsetWidth,
        offset: this.getOffsetImgItem(this.iot.visual)
      },
      BIM: {
        imgSize: this.bim.visual.offsetWidth,
        offset: this.getOffsetImgItem(this.bim.visual)
      },
      CHAIN: {
        imgSize: this.chain.visual.offsetWidth,
        offset: this.getOffsetImgItem(this.chain.visual)
      },
      SERVICE: {
        imgSize: this.serviceImgEl.offsetWidth,
        offset: this.getOffsetImgItem(this.serviceImgEl)
      },
      CONTACT: {
        imgSize: this.contactLinkImgEl.offsetWidth,
        offset: this.getOffsetImgItem(this.contactLinkImgEl)
      },
    })
  }

  public play(): void {
    super.play();

    this.mainGL.startLoop();
    this.updateGLScales();

    this.mainGL.play(()=> {
      this.isLocked = false;
      this.mainGL.setMode('KV');
      this.mainGL.setKVIndex(0);
      this.pageKV.play();
    }, false);
  }
}